import React, { useContext } from 'react';
import { store } from 'components/Store';
import time from 'utils/time';
import useTopicOrClientWord from 'components/Dashboard/hooks/useTopicOrClientWord';
import Visibility from './ui/Visibility';
import getAppSite from 'utils/getAppSite';
const InfluenceVisibilityContainer = (props) => {
  const globalState = useContext(store);
  const { state } = globalState;
  const { activePlan } = state;
  const { sectionValues, type } = props;
  const { fields } = sectionValues;
  const influenceTypeName = type === 'policy-asks' ? 'policy ask' : 'briefing material';
  const { agencyUser } = useTopicOrClientWord();
  const options = [
    {
      title: 'Anyone',
      subtext: `Organisations, ${getAppSite() === 'usa' ? 'policymakers' : 'parliamentarians'} and others will be able to see and support your ${influenceTypeName}`,
      option: 'Anyone',
    },
    {
      title: 'Stakeholders only',
      subtext: `Only ${getAppSite() === 'usa' ? 'policymakers' : 'parliamentarians'} and their staff registered on PolicyMogul will be able to see and support your ${influenceTypeName}`,
      option: 'StakeholdersOnly',
      disabled: !activePlan?.enableUserContentStakeholderOnly,
    },
    {
      title: 'Stakeholders and anyone with link',
      subtext: `${getAppSite() === 'usa' ? 'Policymakers' : 'Parliamentarians'} and their staff registered on PolicyMogul, and anyone you share the URL with, will be able to see and support your ${influenceTypeName}`,
      option: 'StakeholdersOnlyOrLink',
      disabled: !activePlan?.enableUserContentStakeholderOnly,
    },
  ];

  const dateOptions = [
    {
      name: '1 month',
      value: time.formatDate(1, 'month'),
    },
    {
      name: '3 months',
      value: time.formatDate(3, 'month'),
    },
    {
      name: '6 months',
      value: time.formatDate(6, 'month'),
    },
    {
      name: '12 months',
      value: time.formatDate(12, 'month'),
    },
    {
      name: 'On a specific date',
      value: 'picker',
    },
    {
      name: 'No expiry date',
      value: null,
    },
  ];
  const compileVisibilityOptions = () => {
    let visibilityOptions = {
      visibility: {
        options: options,
      },
      organisationWebsite: {},
      websiteLink: {},
      date: {
        options: dateOptions,
      },
      location: {},
      keywords: {},
    };
    if (agencyUser) {
      delete visibilityOptions.websiteLink;
    }
    let items = Object.keys(visibilityOptions);
    let changeValues = (field) => {
      switch (field) {
        case 'location':
          return 'region';
        case 'date':
          return 'expirationDate';
        default:
          return field;
      }
    };
    let findItem = (field) => {
      return fields.find((item) => item.name === changeValues(field));
    };
    items.forEach((item) => {
      visibilityOptions[item].value = findItem(item)?.value;
      visibilityOptions[item].setValue = findItem(item)?.setValue;
    });
    return visibilityOptions;
  };
  return <Visibility visibilityOptions={compileVisibilityOptions()} {...props} />;
};

export default InfluenceVisibilityContainer;
